import React, { useState, useEffect, useRef, useContext } from "react";
import { Message_data } from "../context/context";
import cn from "classnames";
import { FALLBACK_COVERART } from "../lib/fallbackCoverart";

export const JukeboxList4 = ({
  jukebox,
  setRequestedTrack,
  pickTrack,
  viewNextTrack,
  youtubeVideos,
  onYoutubeVideoClick,
  isSearchingYoutube,
  djLibraryTracks = [],
  onDjLibraryClick,
}) => {
  // console.log('updated',jukebox);
  const csp = useRef(null);
  const [jukeboxList, setJukeboxList] = useState([]);
  const [currentSongId, setCurrentSongId] = useState(null);

  const { message, setMessage } = useContext(Message_data);
  const [, updateState] = React.useState();
  const forceUpdate = React.useCallback(() => updateState({}), []);

  useEffect(() => {
    const playerControlData = async () => {
      if (message) {
        const data = JSON.parse(message);
        if (data.triggerScroll) {
          csp.current.scrollIntoView({ behavior: "smooth", block: "end" });
        }
      }
    };
    playerControlData();
  }, [message]);

  useEffect(() => {
    // console.log('updated jukebox', jukebox)
    setJukeboxList(jukebox);
  }, [jukebox]);

  return (
    <>
      {/* <div className="flex flex-row mt-4">
              <button
                type="button"
                class="text-black w-2/4 bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-yellow-300 dark:focus:ring-yellow-800 font-medium rounded-lg text-lg px-2 py-2 text-center me-2 mb-2 mr-2"
                onClick={() => {
                  //   const element = document.getElementById("currentsongplaying");
                  //   if (!element) return;
                  csp.current.scrollIntoView({
                    behavior: "smooth",
                    block: "end",
                  });
                }}
              >
                <div className="flex items-center justify-center">
                  <div>PLAYING NOW</div>
                  <svg
                    style={{ color: "white" }}
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    fill="currentColor"
                    viewBox="0 0 16 16"
                  >
                    {" "}
                    <path
                      d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"
                      fill="yellow"
                    ></path>{" "}
                  </svg>
                </div>
              </button>
              <button
                type="button"
                class="text-black w-2/4 bg-gradient-to-r from-green-400 via-green-500 to-green-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-green-300 dark:focus:ring-green-800 font-medium rounded-lg text-lg px-2 py-2 text-center me-2 mb-2 mr-2"
                onClick={(e) => {
                  viewNextTrack(e);
                }}
              >
                <div className="flex items-center justify-center">
                  <div>VIEW NEXT SONG</div>
                  <svg
                    style={{ color: "white" }}
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    fill="currentColor"
                    viewBox="0 0 16 16"
                  >
                    {" "}
                    <path
                      d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"
                      fill="yellow"
                    ></path>{" "}
                  </svg>
                </div>
              </button>
            </div> */}
      {/* <h2 className="text-white uppercase mt-2">Individual Tracks</h2> */}

      <div className="flex flex-wrap justify-left mt-2 h-20 overflow">
        <div className="w-full lg:w-1/2">
          {jukeboxList &&
            jukeboxList.map((item, i) => (
              <div key={i}>
                <div className="post flex flex-row justify-between text-left text-white">
                  <div className="flex flex-row">
                    <img
                      src={item.coverart || FALLBACK_COVERART}
                      alt="cover art"
                      className="w-full lg:w-1/2 rounded-full mr-4"
                      style={{ width: "64px", height: "64px" }}
                      onError={(e) => {
                        const src = e.target.getAttribute('data-original-src');
                        if (!src) {
                          e.target.setAttribute('data-original-src', e.target.src);
                          e.target.src = FALLBACK_COVERART;
                          setTimeout(() => {
                            e.target.src = e.target.getAttribute('data-original-src');
                          }, 3000);
                        } else {
                          e.target.onerror = null;
                          e.target.src = FALLBACK_COVERART;
                        }
                      }}
                    />
                    <div>
                      <p className="title text-white text-left pb-2">
                        <strong>{item.track}</strong>
                      </p>
                      <p className="title text-sm text-white text-left leading-8">
                        {item.artist}
                      </p>
                    </div>
                  </div>

                  <button
                    className="h-16 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors duration-300"
                    onClick={(event) => {
                      setRequestedTrack(item);
                      pickTrack(event, item, i);
                    }}
                  >
                    request
                  </button>
                </div>
              </div>
            ))}

          {/* DJ's Library Results — tracks on the DJ's desktop drive that
              match the search but aren't in the loaded playlist. Always
              rendered ABOVE the YouTube results. */}
          {djLibraryTracks && djLibraryTracks.length > 0 ? (
            <>
              <div style={{
                marginTop: '2rem',
                marginBottom: '1rem',
                paddingTop: '1rem',
                borderTop: '2px solid rgba(34, 197, 94, 0.3)'
              }}>
                <h3 style={{
                  color: '#22c55e',
                  fontSize: '1rem',
                  fontWeight: '700',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  marginBottom: '1rem'
                }}>
                  In The DJ's Library
                </h3>
              </div>

              {djLibraryTracks.map((tr) => (
                <div key={`djlib-${tr.id}`}>
                  <div className="post flex flex-row justify-between text-left text-white">
                    <div className="flex flex-row">
                      <img
                        src={tr.c || "img/muuzbox-logo.png"}
                        alt="cover art"
                        className="w-full lg:w-1/2 rounded-full mr-4"
                        style={{ width: "64px", height: "64px" }}
                        onError={(e) => {
                          // Broken coverart URL → try the logo; broken logo →
                          // inline SVG lettering (never breaks).
                          e.target.onerror = null;
                          if (e.target.src.indexOf("muuzbox-logo.png") === -1) {
                            e.target.src = "img/muuzbox-logo.png";
                            e.target.onerror = (e2) => { e2.target.onerror = null; e2.target.src = FALLBACK_COVERART; };
                          } else {
                            e.target.src = FALLBACK_COVERART;
                          }
                        }}
                      />
                      <div>
                        <p className="title text-white text-left pb-2">
                          <strong>{tr.t}</strong>
                        </p>
                        <p className="title text-sm text-white text-left leading-8">
                          {tr.a || "Unknown Artist"}
                        </p>
                      </div>
                    </div>

                    <button
                      className="h-16 px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition-colors duration-300"
                      onClick={() => onDjLibraryClick && onDjLibraryClick(tr)}
                    >
                      Request
                    </button>
                  </div>
                </div>
              ))}
            </>
          ) : null}

          {/* YouTube Results */}
          {(youtubeVideos && youtubeVideos.length > 0) || isSearchingYoutube ? (
            <>
              <div style={{
                marginTop: '2rem',
                marginBottom: '1rem',
                paddingTop: '1rem',
                borderTop: '2px solid rgba(250, 22, 63, 0.3)'
              }}>
                <h3 style={{
                  color: '#fa163f',
                  fontSize: '1rem',
                  fontWeight: '700',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  marginBottom: '1rem'
                }}>
                  Muuzbox Internet Results
                </h3>
              </div>

              {isSearchingYoutube && (!youtubeVideos || youtubeVideos.length === 0) ? (
                <div style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  padding: '2rem',
                  color: 'rgba(255,255,255,0.6)'
                }}>
                  <div style={{
                    border: '3px solid rgba(250, 22, 63, 0.2)',
                    borderTop: '3px solid #fa163f',
                    borderRadius: '50%',
                    width: '40px',
                    height: '40px',
                    animation: 'spin 1s linear infinite'
                  }}></div>
                  <style>{`
                    @keyframes spin {
                      0% { transform: rotate(0deg); }
                      100% { transform: rotate(360deg); }
                    }
                  `}</style>
                </div>
              ) : (
                youtubeVideos && youtubeVideos.map((video) => (
                  <div key={video.id.videoId}>
                    <div className="post flex flex-row justify-between text-left text-white">
                      <div className="flex flex-row">
                        <img
                          src={video.snippet.thumbnails.medium?.url || video.snippet.thumbnails.default?.url || FALLBACK_COVERART}
                          alt="cover art"
                          className="w-full lg:w-1/2 rounded-full mr-4"
                          style={{ width: "64px", height: "64px" }}
                          onError={(e) => { e.target.onerror = null; e.target.src = FALLBACK_COVERART; }}
                        />
                        <div>
                          <p className="title text-white text-left pb-2">
                            <strong>{video.snippet.title}</strong>
                          </p>
                          <p className="title text-sm text-white text-left leading-8">
                            {video.snippet.channelTitle}
                          </p>
                        </div>
                      </div>

                      <button
                        className="h-16 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors duration-300"
                        onClick={() => onYoutubeVideoClick(video)}
                      >
                        request
                      </button>
                    </div>
                  </div>
                ))
              )}
            </>
          ) : null}
        </div>
      </div>
    </>
  );
};
